import {render} from "vike/abort";

export async function guard(pageContext) {
  if (pageContext.pageError) {
    throw render(500, "Strona Ja, Rock! aktualnie nie działa, spróbuj ponownie później.");
  }
}